import { useMemo } from "react";

import { useAnswerContext } from "../onboarding/AnswerContext";

const TOTAL_ESTIMATED_SECONDS = 120; // 2 minutes max

interface EstimatedTime {
  remainingSeconds: number;
  displayText: string;
}

export const useEstimatedTime = (): EstimatedTime => {
  const { progressPercent } = useAnswerContext();

  const { remainingSeconds, displayText } = useMemo(() => {
    // Calculate remaining percentage (100% - current progress)
    const remainingPercent = Math.max(0, 100 - progressPercent);

    // Calculate remaining seconds based on remaining percentage
    const seconds = Math.round(
      (remainingPercent / 100) * TOTAL_ESTIMATED_SECONDS,
    );

    let text = "";

    if (seconds === 0) {
      text = "Your personalized recommendations are ready!";
    } else if (seconds <= 15) {
      text = "ETA: less than 15s remaining before finishing";
    } else if (seconds <= 30) {
      text = "ETA: less than 30s remaining before finishing";
    } else if (seconds <= 60) {
      text = "ETA: less than 1 minute remaining before finishing";
    } else if (seconds <= 90) {
      text = "ETA: less than 1m30 remaining before finishing";
    } else {
      text = "ETA: less than 2 minutes remaining before finishing";
    }

    return {
      remainingSeconds: seconds,
      displayText: text,
    };
  }, [progressPercent]);

  return { remainingSeconds, displayText };
};
